<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-5 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <Overview
          v-if="profitData && sellData && warehouseData && crmData"
          :profit-data="profitData"
          :sell-data="sellData"
          :warehouse-data="warehouseData"
          :crm-data="crmData"
        />
      </v-container>
      <!-- section 2 -->
      <v-container class="pa-0 ma-0">
        <QuickAccess
          v-if="PurchaseData && sellData && warehouseData && crmData && CostData"
          :purchase-data="PurchaseData"
          :cost-data="CostData"
          :sell-data="sellData"
          :warehouse-data="warehouseData"
          :crm-data="crmData"
          :tax-data="taxData"
        />
      </v-container>
      <!-- section 3 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!-- Area Chart-->
          <v-col cols="12" md="12">
            <AreaSellBuyChart />
          </v-col>
          <!-- Spider Chart-->
          <!-- <v-col cols="12" md="4">
            <SpiderSellBuyChart
              v-if="PurchaseData && sellData && warehouseData && crmData && CostData"
              :purchase-data="PurchaseData"
              :cost-data="CostData"
              :sell-data="sellData"
              :warehouse-data="warehouseData"
              :crm-data="crmData"
            />
          </v-col> -->
        </v-row>
      </v-container>

      <!-- section 4 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!-- insights-->
          <v-col cols="12" md="6">
            <Insights
              v-if="PurchaseData && sellData && warehouseData && crmData && CostData"
              :purchase-data="PurchaseData"
              :cost-data="CostData"
              :sell-data="sellData"
              :warehouse-data="warehouseData"
              :crm-data="crmData"
            />
          </v-col>
          <!-- useful reports-->
          <v-col cols="12" md="6">
            <UsefulReports />
          </v-col>
        </v-row>
      </v-container>

      <!-- section 5 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--Top Customers -->
          <v-col cols="12" md="6">
            <TopCustomers />
          </v-col>
          <!-- top products-->
          <v-col cols="12" md="6">
            <TopProducts />
          </v-col>
        </v-row>
      </v-container>
      <!-- section 6 -->
      <v-container class="pa-0 ma-0">
        <!-- <RecentActivities /> -->
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import Overview from "./partial/Overview.vue";
import QuickAccess from "./partial/QuickAccess.vue";
import AreaSellBuyChart from "./partial/AreaSellBuyChart.vue";
import SpiderSellBuyChart from "./partial/SpiderSellBuyChart.vue";
import Insights from "./partial/Insights.vue";
import TopCustomers from "./partial/TopCustomers.vue";
import TopProducts from "./partial/TopProducts.vue";
import UsefulReports from "./partial/UsefulReports.vue";
import RecentActivities from "./partial/RecentActivities.vue";

export default {
  name: "dashboerd",
  components: {
    Overview,
    QuickAccess,
    AreaSellBuyChart,
    SpiderSellBuyChart,
    Insights,
    TopCustomers,
    TopProducts,
    UsefulReports,
    RecentActivities,
  },
  data: () => ({
    sellData: null,
    profitData: null,
    warehouseData: null,
    PurchaseData: null,
    crmData: null,
    CostData: null,
    taxData: null,
    loading: false,
  }),
  mounted() {
    this.getDashboardData();
  },
  methods: {
    getDashboardData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.sellData = res.sumSell;
          app.profitData = res.totalProfit;
          app.warehouseData = res.EntrepotSummary;
          app.crmData = res.crmReport;
          app.PurchaseData = res.sumPurchase;
          app.CostData = res.totalCost;
          app.taxData = res.InvoiceTaxCount;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
